import {createAction} from "redux-act";
import {IAchievement} from "modules/reducers";

export const requestUserAchievements = createAction();
export const requestUserAchievementsSuccess = createAction<IAchievement[]>();
export const requestUserAchievementsFailed = createAction();
